import { render, staticRenderFns } from "./DatabaseAddCombo.vue?vue&type=template&id=5d7b0267&"
import script from "./DatabaseAddCombo.vue?vue&type=script&lang=js&"
export * from "./DatabaseAddCombo.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseAddCombo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports